export const LOCALES_SUPPORTED = {
  en: 'English',
  en_US: 'English (US)',
  nl: 'Dutch',
  sv: 'Swedish',
  es: 'Spanish',
  fr: 'French',
  de: 'German',
  pl: 'Polish',
  pt: 'Portuguese',
  it: 'Italian',
  da: 'Danish',
  fi: 'Finnish',
  no: 'Norwegian',
  th: 'Thai',
}

export const LOCALES_SUPPORTED_LEAD_CAPTURE_FORM = {
  en: 'English',
  en_US: 'English (US)',
  nl: 'Dutch',
  sv: 'Swedish',
  es: 'Spanish',
  fr: 'French',
  de: 'German',
  pl: 'Polish',
  pt: 'Portuguese',
  it: 'Italian',
  da: 'Danish',
  fi: 'Finnish',
  no: 'Norwegian',
}

export { LOCALES_SUPPORTED_CUSTOMER_FACING } from 'opensolar-common'
